export default __webpack_public_path__ + "static/media/risk_management.e41e2b16.svg";